import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useMediaQuery from 'shared/hooks/useMediaQuery';
import { isActiveOrder, isRejectedOrder } from 'shared/models/order';
import { latestOrder } from 'shared/models/user';
import { loadOrder } from './actions';
import NullErrorBoundary from 'components/errorPages/NullErrorBoundary';

const OrderTrackingPanel = React.lazy(() => import('./Panel'));

export default function StorefrontOrderTracking({ user }) {
  const dispatch = useDispatch();
  const order = useSelector(state => state.orderTracking.order || {});
  const tipStarted = useSelector(state => state.orderTracking.tipStarted);
  const currentOrder = latestOrder(user) || {};
  const isTrackable =
    currentOrder &&
    !currentOrder.shipping &&
    (isActiveOrder(currentOrder) || isRejectedOrder(currentOrder));

  useEffect(() => {
    if (isTrackable && order._id !== currentOrder._id) {
      dispatch(loadOrder(currentOrder._id));
    }
  }, [currentOrder._id, dispatch, isTrackable, order._id]);

  const isSmallScreen = useMediaQuery('(max-width: 767px)');
  if (!isSmallScreen) return null;

  if (!currentOrder || currentOrder.shipping || tipStarted) return null;

  return (
    <NullErrorBoundary>
      <React.Suspense fallback={null}>
        <OrderTrackingPanel order={order} />
      </React.Suspense>
    </NullErrorBoundary>
  );
}
